var common = {
  namespaced: true,
  state: {
    test: 456
  },
  mutations: {},
  actions: {},
  getters: {}
};
export default common;